import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';


import Vue from 'vue'

const getDefaultStateForAssets = () => {
    return {
        is_child_added:null,
        is_child_deleted:null,
        assets:[],
        asset_data:{},
        asset_classifications:[],
        rfids:[],
        filter:{
            keyword:"",
            active_only:"1"
        },
        acquisition_date: '2021-01-01',
        acquisition_value: 10000,
        depreciation_duration_months: 12,
        residual_value: 1000,       
        is_created:null,
        is_updated:null,
        is_deleted:null
    }
}

// state
const state = getDefaultStateForAssets()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_ASSETS (state) {
        Object.assign(state, getDefaultStateForAssets())
    },
    SET_ASSET_CLASSIFICATIONS(state, data){
        state.asset_classifications = data
    },
    SET_RFIDS(state, data){
        state.rfids = data
    },
    FETCH_ALL(state, data){
        state.assets = data
    },
    FETCH(state, data){
      state.asset_data = data
    },
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    },
    SET_IS_CREATED(state, data){
        state.is_created = data
    },
    SET_IS_UPDATED(state, data){
        state.is_updated = data
    },
    SET_IS_CHILD_ADDED(state, data){
      state.is_child_added = data
    },
    SET_IS_CHILD_DELETED(state, data){
      state.is_child_deleted = data
    },
    QUICK_SEARCH(state, data){
    //     data.forEach(function (element) {
    //       element.contact_email = (element.contact_email != null && element.contact_email != '') ? (element.contact_email) : '-'
    //       element.contact_telephone = (element.contact_telephone != null && element.contact_telephone != '') ? (element.contact_telephone) : '-'

    //   });
      state.assets = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    FETCH(state, data)
    {
        state.asset_data = data
    }
}

// actions
const actions = {
    resetState({ commit }, payload) {
        commit("RESET_STATE_FOR_ASSETS")
    },
    fetch({ commit }, data) {
        return axios.post(apiRoutes['RETRIEVE_ASSET'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH', response.data.data)
              } else {
                commit('FETCH', {})
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
     },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_ASSET'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Asset code has been created",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                commit("SET_IS_CREATED", 1)

            }
            else
            {
                let errors = response.data.data.errors
                commit("SET_IS_CREATED", 0)

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Asset")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['UPDATE_ASSET'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: "Asset has been updated",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                commit("SET_IS_UPDATED", 1)

            }
            else
            {
                let errors = response.data.data.errors
                commit("SET_IS_UPDATED", 0)
                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application exception")
              }
          });
    },
    async addAssetChildern({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['ADD_ASSET_CHILDREN'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                commit("SET_IS_CHILD_ADDED", 1)

            }
            else
            {
                let errors = response.data.data.errors
                commit("SET_IS_CHILD_ADDED", 0)
                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application exception")
              }
          });
    },
    
    async deleteChild({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['DELETE_ASSET_CHILDREN'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Link Asset has been deleted",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  //dispatch("customers/fetch", {"code":data.contact_code}, {root:true})
                 // commit("SET_BANK_ACCOUNT_ID", id)
                 commit("SET_IS_CHILD_DELETED", 1)
  
              }
              else
              {
                  commit("SET_IS_CHILD_DELETED", 0)

                  let errors = response.data.data.errors
  
                  if(Array.isArray(errors))
                  {
                    console.log(errors)
                    let msg = errors.join("\n")
  
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)
                commit("SET_IS_CHILD_DELETED", 0)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    //console.log("Problem submitting New Post", error);
                    alert("Application exception")
                }
            });
    },
    async listAssetClassifications({ commit }, data) {
        return axios.post(apiRoutes['LIST_ASSET_CLASSIFICATIONS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('SET_ASSET_CLASSIFICATIONS', response.data.data)
              } 
              else 
              {
                commit('SET_ASSET_CLASSIFICATIONS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem querying data", error);
              }
          });
    },
    async listRfids({ commit }, data) {
        console.log(data)
        return axios.post(apiRoutes['LIST_RFID_FOR_ASSETS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('SET_RFIDS', response.data.data)
              } 
              else 
              {
                commit('SET_RFIDS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem querying data", error);
              }
          });
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['ASSETS_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('QUICK_SEARCH', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('QUICK_SEARCH', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem submitting New Customer", error);
              }
          });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
